<div class="icon-text">
  <div>
    <span style="color: black;font-weight: 500;font-size: 18px;"><img class="bell-icon"
        src="/assets/images/hand.png" style="margin-right: 3px;margin-bottom: 6px;" alt=""> {{ welcomeText }}</span><br>
    <span style="color: black;margin-left: 35px;">{{ subText }}</span>
  </div>
  <div class="daterange">
    <ng-container *ngIf="showToggle">
      <span class="mr-2" style="font-weight: 500;">All Outlets</span>
      <label class="switch mr-1">
        <input type="checkbox" [checked]="isActiveOutlet" (change)="onToggle($event)">
        <span class="slider-outlet"></span>
      </label>
      <span class="mr-2" style="font-weight: 500;">Hyperlocal Outlets</span>
    </ng-container>
    <button class="header-btn" *ngIf="showDateRange" (click)="onOpenDateRangePicker()">
      <img style="width: 12px;margin-left: 3px;margin-right: 8px;margin-bottom: 2px;"
        [src]="bucketurl + '/images/calender.png'" alt="">Date Range
    </button>
  </div>
</div>
